<template>
  <div class="check-list-phone auto-list_col_centered">
    <div>
      <p :class="showDeletedList ? 'red' : ''">
        {{ responseAuto ? responseAuto.state_numbers : 'Нет данных' }}
      </p>
      <p :class="showDeletedList ? 'red' : ''">
        {{ responseAuto ? responseAuto.state_numbers_trailer : 'Нет данных' }}
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'StateNumbers',
  props: {
    responseAuto: {
      type: Object,
      default: () => {},
    },
    showDeletedList: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style scoped>
.red {
  color: #f00;
}
</style>
